<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <div class="left-box flex-shrink" :style="{ paddingTop: scrollY + 'px', width: width + 'px', maxHeight: rightBoxHeight + 'px' }">
      <div class="tree-block pb-lg">
        <el-input placeholder="输入关键字进行过滤" v-model="filterText">
        </el-input>
        <el-tree node-key="wareHouseId" :defaultExpandedKeys=[queryParams.parentWareHouseId] :current-node-key="queryParams.parentWareHouseId" highlight-current class="filter-tree"
          :props="defaultProps" :data="wareHouseData" :filter-node-method="filterNode" @node-click="handleSelect"
          ref="tree">
        </el-tree>
      </div>
      <xiaobu-drag class="myxhandle" @widthChange="widthChange" />
    </div>
    <div ref="rightBox" id="wareHouseRightBox" class="right-box flex-grow"
      :style="{ width: `calc(100% - ${width}px)` }">
      <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
        <el-form-item class="search-field fl five-per-row" label="仓库名称" prop="wareHouseName">
          <el-input v-model.trim="queryParams.wareHouseName" placeholder="请输入仓库名称" clearable
            @keyup.enter.native="handleQuery" />
        </el-form-item>
        <el-form-item class="search-field fl five-per-row" label="创建时间" prop="beginTime">
          <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
        </el-form-item>

        <el-form-item class="fr">
          <el-button plain @click="resetQuery">重 置</el-button>
          <el-button type="primary" @click="handleQuery">查 询</el-button>
        </el-form-item>
      </el-form>
      <div class="table-wrap">
        <div class="table-control-box">
          <el-button v-hasPermission="['wareHouse:create']" type="primary" plain icon="el-icon-plus" size="mini"
            @click="handleAdd">新增</el-button>
          <el-button v-hasPermission="['wareHouse:update']" type="success" plain icon="el-icon-edit" size="mini"
            :disabled="single" @click="handleUpdate">编辑</el-button>
          <el-button v-hasPermission="['wareHouse:delete']" type="danger" plain icon="el-icon-delete" size="mini"
            :disabled="multiple" @click="handleBatchDelete">删除</el-button>
        </div>
        <div class="table-box">
          <auto-height-table ref="wareHouseTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
            v-loading="loading" :data="list" row-key="wareHouseId" @selection-change="handleSelectionChange"
            @row-click="clickRow">
            <el-table-column :reserve-selection="true" type="selection" width="55" align="center" />
            <el-table-column label="仓库名称" prop="wareHouseName" align="center" min-width="168px" />
            <el-table-column label="库存数量" prop="quantity" align="center" min-width="128px" />
            <el-table-column label="仓库容量" prop="maxQuantity" align="center" min-width="128px" />
            <el-table-column label="仓库使用率" prop="maxQuantity" align="center" min-width="128px" >
              <template slot-scope="scope">
                {{((scope.row.quantity / scope.row.maxQuantity) * 100).toFixed(2)}}%
              </template>
            </el-table-column>
            <el-table-column-dict dictType="CAPACITY_STATUS" dictTypeNode="tag" label="仓库状态"  prop="capacityStatus" align="center" min-width="168px" />
            <el-table-column label="操作人" prop="creator.userName" show-overflow-tooltip align="center" min-width="168px">
              <template slot-scope="scope">
                <div class="operater-box flex-c-c">
                  <div class="operater-content-box">
                    <div class="top">
                      <span class="label">创建人：</span>
                      <span class="value">{{ scope.row.creator?.userName || "--" }}</span>
                    </div>
                    <div class="bottom">
                      <span class="label">更新人：</span>
                      <span class="value">{{ scope.row.updater?.userName || "--" }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column dateFormat="datetime" label="操作时间" align="center" prop="createTime" min-width="256px">
              <template slot-scope="scope">
                <div class="operater-box flex-c-c">
                  <div class="operater-content-box">
                    <div class="top">
                      <span class="label">创建时间：</span>
                      <span class="value">{{ scope.row.createTime | formatDate("datetime", "--") }}</span>
                    </div>
                    <div class="bottom">
                      <span class="label">更新时间：</span>
                      <span class="value">{{ scope.row.updateTime | formatDate("datetime", "--") }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column v-if="
              mixinHasPermi([
                'wareHouse:read',
                'wareHouse:delete',
                'wareHouse:setManager'
              ])
            " label="操作" align="center" width="260px" fixed="right" class-name="small-padding ">
              <template slot-scope="scope">
                <el-button v-hasPermission="['wareHouse:read']" size="mini" type="primary" icon="el-icon-view"
                  @click.native.stop="handleUpdate(scope.row)">查看</el-button>
                <el-button v-hasPermission="['wareHouse:delete']" size="mini" type="danger" icon="el-icon-delete"
                  :disabled="scope.row.hasChildren || scope.row.beUsedInWareHouseSpu"
                  @click.native.stop="handleDelete(scope.row)">删除</el-button>
                <el-button type="primary" size="mini" v-hasPermission="['wareHouse:setManager']"
                  v-if="permissionLength <= 2">分配管理员</el-button>
                <el-dropdown v-if="
                  mixinHasPermi(['wareHouse:setManager']) && permissionLength > 2
                " @command="(command) => handleCommand(command, scope.row)">
                  <span class="el-dropdown-link more" @click.stop>
                    <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :disabled="scope.row.hasChildren" v-hasPermission="['wareHouse:setManager']"
                      command="handleSetManager">分配管理员</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </auto-height-table>
          <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize" @pagination="getList" />
        </div>
      </div>
    </div>

    <!-- 添加或编辑对话框 -->
    <ware-house-dialog ref="wareHouseDialog" :wareHouseData="wareHouseData" :props="props" :visible.sync="open"
      :modal-append-to-body="false" :close-on-click-modal="false" :isUpdate="isUpdate" :baseForm="baseForm"
      @close="open = false" @successs="handleWareHouseChange" width="1024px">
    </ware-house-dialog>

    <select-manager v-if="mixinHasPermi(['wareHouse:setManager'])" :title="selectManagerTitle" ref="wareHouseManager"
      width="1000px" :visible.sync="showSelectManager" @close="showSelectManager = false" :modal-append-to-body="true"
      :append-to-body="true" :close-on-click-modal="false" :wareHouseId="selectManagerWareHouseId"></select-manager>
  </div>
</template>

<script>
import { wareHouseApi } from "@/api"
import WareHouseDialog from "./components/ware-house-dialog.vue"
import SelectManager from "./components/select-manager.vue"
import { debounce } from "vue2-element-admin-plugin"
export default {
  name: "wareHouseManage",
  components: {
    WareHouseDialog,
    SelectManager
  },
  data() {
    return {
      scrollY: "",
      rightBoxHeight: 500,
      selectManagerTitle: "", // 分配管理员标题
      showSelectManager: false, // 分配管理员弹窗
      selectManagerWareHouseId: "", // 管理员仓库id

      width: 200,
      wareHouseData: [], // 仓库树 数据
      defaultProps: {
        children: "children",
        label: "wareHouseName"
      },
      filterText: "",
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        parentWareHouseId: "ROOT_VALUE", // 父级仓库id
        wareHouseName: "", // 名称
        status: "", //
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      selection: [], //选中的项
      loading: false,
      total: 0,

      // 非单个禁用
      single: true,
      // 非多个禁用(0个禁用)
      multiple: true,

      open: false,
      // 表单参数
      baseForm: {
        parentWareHouseId: "", // 父级仓库
        wareHouseName: "", // 仓库名
        maxQuantity: "", // 仓库容量
        quantity: "0", // 当前库存量
        remark: "" // 备注
      },
      dialogForm: {}, // 弹框表单
      // 表单校验
      rules: {

      },
      props: {
        value: "wareHouseId",
        label: "wareHouseName",
        checkStrictly: true,
        emitPath: false
      },
      queryOptions: [],
      options: [] // 仓库值父元素id
    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          parentWareHouseId: "", // 父级仓库
          wareHouseName: "", // 仓库名
          maxQuantity: "", // 仓库容量
          quantity: "0", // 0
          remark: "" // 备注
        }
        this.$refs.wareHouseDialog && this.$refs.wareHouseDialog.resetForm()
      }
    },
    filterText(val) {
      this.$refs.tree.filter(val)
    },
    showSelectManager(val) {
      if (!val) {
        this.selectManagerWareHouseId = ""
        this.$refs.wareHouseManager && this.$refs.wareHouseManager.clearSelection()
        this.selectManagerTitle = ""
      }
    }
  },
  computed: {
    // 三个按钮权限中 有多少个按钮权限
    permissionLength() {
      const permissionList = this.$store.getters.permissionList
      const list = [
        "wareHouse:read",
        "wareHouse:delete",
        "wareHouse:setManager"
      ]
      let num = 0
      for (let i = 0; i < list.length; i++) {
        const item = list[i]
        if (permissionList.includes(item)) {
          num++
        }
      }
      return num
    }
  },

  async created() {
    await this.init()
    window.addEventListener("scroll", this.handleScroll)
    this.$nextTick(() => {
      this.rightBoxHeight = this.$refs.rightBox.offsetHeight
    })
  },
  mounted() {
    const element = document.getElementById("wareHouseRightBox")

    const observer = new ResizeObserver(entries => {
      // for (const entry of entries) {
      //   const width = entry.contentRect.width
      //   console.log(`Element width: ${width}px`)
      // }
      this.resize()
    })

    observer.observe(element)

    //清除监听
    this.$once("hook:beforeDestroy", () => {
      // 停止观察
      observer.disconnect()
      window.removeEventListener("scroll", this.handleScroll)
    })
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY || 20
    },
    // 重新设置左边的最大高度
    resize: debounce(function(val) {
      this.rightBoxHeight = 500
      setTimeout(() => {
        this.rightBoxHeight = this.$refs.rightBox.offsetHeight
      }, 10)
    }, 300),
    // 更多操作
    handleCommand(command, row) {
      if (command === "handleSetManager") {
        this.handleSetManager(row)
      }
    },
    handleSetManager(row) {
      this.selectManagerTitle = `分配管理员（${row.wareHouseName}）`
      this.selectManagerWareHouseId = row.wareHouseId
      this.showSelectManager = true
    },
    // 初始化
    init() {
      const getArr = [
        this.handleQuery(),
        this.getParentIdList()
      ]
      return Promise.all(getArr)
    },
    // 仓库编辑或者新增成功事件
    async handleWareHouseChange() {
      this.$store.dispatch("user/getUserInfo")
      await this.init()
    },

    /**
     * @description: 监听拉伸事件
     */
    widthChange(movement) {
      this.width -= movement
      if (this.width < 150) {
        this.width = 150
      }
      if (this.width > 700) {
        this.width = 700
      }
    },
    // 过滤父级仓库选项
    filterNode(value, data) {
      if (!value) {
        return true
      }
      return data.wareHouseName.indexOf(value) !== -1
    },
    // 选中后数据
    handleSelect(data) {
      if (data.wareHouseId === this.queryParams.parentWareHouseId) {
        return
      }
      this.queryParams.pageNum = 1
      if (data) {
        this.queryParams.parentWareHouseId = data.wareHouseId
      } else {
        this.queryParams.parentWareHouseId = ""
      }
      // 切换父级仓库时 清空已选项
      this.$refs.wareHouseTable && this.$refs.wareHouseTable.clearSelection()
      this.getList()
    },
    // 获取仓库列表
    getParentIdList() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        if (data.length === 0) {
          this.wareHouseData = [
            {
              wareHouseName: "根仓库",
              wareHouseId: "ROOT_VALUE"
            }
          ]
          return
        }
        this.wareHouseData = [
          {
            wareHouseName: "根仓库",
            wareHouseId: "ROOT_VALUE",
            children: data
          }
        ]
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.queryParams.parentWareHouseId)
        })
      })
    },
    //点击行
    clickRow(row) {
      this.$refs.wareHouseTable && this.$refs.wareHouseTable.toggleRowSelection(row)
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.mixinBtnBlur()

      let str = ""
      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.wareHouseId)
        str += item.wareHouseName
        if (i !== this.selection.length - 1) {
          str += ", "
        }
      }

      this.$modal
        .confirm('是否确认删除仓库项为"【' + str + '】"的数据项？')
        .then(function() {
          return wareHouseApi.batchDeleteItems({ ids })
        })
        .then(() => {
          this.init()
          this.$modal.msgSuccess("批量删除仓库成功")
        })
        .catch(() => { })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.wareHouseTable && this.$refs.wareHouseTable.clearSelection()
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.mixinResetForm("queryForm")
      this.$refs.tree.setCurrentKey("ROOT_VALUE")
      this.queryParams.parentWareHouseId = "ROOT_VALUE"
      this.baseForm.parentWareHouseId = "ROOT_VALUE"
      this.handleQuery()
    },
    /** 查询角色列表 */
    getList() {
      this.loading = true
      return wareHouseApi
        .getList(this.mixinAddDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.single = selection.length !== 1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      if (this.queryParams.parentWareHouseId === "") {
        this.$modal.msgWarning("请选择仓库节点后再操作！")
        return
      }
      const treeTarget = this.$refs.tree.getCurrentNode()
      const params = {}
      if (treeTarget) {
        params.parentWareHouseId = treeTarget.wareHouseId
      } else {
        params.parentWareHouseId = ""
      }

      this.baseForm = Object.assign(this.baseForm, params)
      this.open = true
    },

    /** 编辑按钮操作 */
    handleUpdate(row) {
      if (!row.wareHouseId) {
        this.isUpdate = true
      }
      const id = row.wareHouseId || (this.selection[0] && this.selection[0].wareHouseId)

      wareHouseApi.getDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      // 让按钮返回原样
      this.mixinBtnBlur()

      const id = row.wareHouseId
      this.$modal
        .confirm('是否确认删除仓库为"' + row.wareHouseName + '"的数据项？')
        .then(function() {
          return wareHouseApi.deleteItem({ id })
        })
        .then(() => {
          this.init()
          this.$modal.msgSuccess("删除成功")
        })
    },
    // 状态改变事件
    handleStatusChange(row) {
      wareHouseApi
        .changeStatus({
          wareHouseId: row.wareHouseId,
          status: row.status === "1" ? "0" : "1"
        })
        .then((data) => {
          this.$modal.msgSuccess("改变状态成功")
          this.getList()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.xiaobu-container {
  height: 100%;
  display: flex;

  .left-box {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: calc(100vh - #{$LayoutHeaderHeight} - #{$LayoutTagsHeight} - 40px);
    padding: 12px;
    background: #ffffff;
    border-radius: 4px;
  }

  .right-box {
    padding-left: 12px;
  }

  .tips {
    font-size: 24px;
    margin-left: 12px;
    color: $mainColor;
  }
}
</style>
